import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const DiamondIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M5.17578 2C4.83178 2 4.617 2.37454 4.79167 2.67188L6.35417 5.33333H9.6237L11.2305 2.67708C11.4105 2.37975 11.1963 2 10.849 2H5.17578ZM3.22266 3.01432C3.07958 3.00841 2.93448 3.06982 2.84115 3.20182L1.76563 4.72266C1.58429 4.97932 1.76673 5.33333 2.08073 5.33333H4.83073L3.58854 3.23307C3.50621 3.09407 3.36574 3.02024 3.22266 3.01432ZM12.7995 3.04818C12.6571 3.05343 12.5166 3.12569 12.4336 3.26302L11.1823 5.33333H13.918C14.232 5.33333 14.4144 4.97802 14.2331 4.72135L13.1797 3.23568C13.0867 3.10468 12.9418 3.04293 12.7995 3.04818ZM2.10677 6.66667C1.78744 6.66667 1.60554 7.03113 1.79688 7.28646L7.33334 14.6667L7.34245 14.6354L5.58073 7.0625C5.52673 6.83117 5.32067 6.66667 5.08334 6.66667H2.10677ZM7.4961 6.66667C7.17276 6.66667 6.93076 6.96328 6.9961 7.27995L7.97657 12.0547L9.02344 7.28776C9.09277 6.96909 8.85074 6.66667 8.52474 6.66667H7.4961ZM10.9206 6.66667C10.6826 6.66667 10.4765 6.83117 10.4232 7.0625L8.66407 14.6602L8.66667 14.6667L14.2018 7.28646C14.3932 7.03113 14.2119 6.66667 13.8932 6.66667H10.9206Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

DiamondIcon.propTypes = {
  sx: PropTypes.object,
};

export default DiamondIcon;
